import apiService from "../apiService"
const practiceApiSlice = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchPractice: builder.query({
      query: (id) => ({ url: `practices/${id}` }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    fetchMyPracticeList: builder.query({
      query: () => ({ url: "practices/mypractices" }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    fetchPracticeList: builder.query({
      query: () => ({ url: "practices" }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    addPractice: builder.mutation({
      query: ({ practice }) => ({
        url: "practices",
        method: "POST",
        body: practice,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    deletePractice: builder.mutation({
      query: (id) => ({
        url: `practices/${id}`,
        method: "DELETE",
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
    updatePractice: builder.mutation({
      query: ({ practice, id }) => ({
        url: `practices/${id}`,
        method: "PUT",
        body: practice,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})

export default practiceApiSlice

export const {
  useLazyFetchPracticeListQuery,
  useLazyFetchPracticeQuery,
  //
  useAddPracticeMutation,
  useUpdatePracticeMutation,
  useDeletePracticeMutation,
  useLazyFetchMyPracticeListQuery,
} = practiceApiSlice
